export default __webpack_public_path__ + "static/media/cloud-active.fcffee55.svg";